module.exports = "/_next/static/images/b96b3a49414be8337f888b0d576dc7fb-footer-superfinanciera-4x.png.webp";